// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ad-container[data-v-fecbeab2]{position:relative;width:100%}.ad-link[data-v-fecbeab2]{display:block;-webkit-text-decoration:none;text-decoration:none}.close-button[data-v-fecbeab2]{background-color:#fff;color:#00aecd;cursor:pointer;font-size:25px;height:32px;position:absolute;right:0;text-align:center;top:0;width:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
